import * as THREE from 'three';
import { Object3D } from 'three';
import GameManager from '../components/GameManager';
import { GameConfig } from '../utils/GameConfig';

export default class Lights extends Object3D {
    constructor(options) {
        super();
        this._setupHelpers();
    }

    /** 
     * Public 
    */

    build() {
        this._createAmbientLight();
        this._createDirectionalLight();
        this._addToScene();
    }

    /** 
     * Private 
    */

    _createAmbientLight() {
        this._aLight = new THREE.AmbientLight(new THREE.Color(GameConfig.ambientLightColor), GameConfig.ambientLightIntensity);
        this._aLight.position.x = 10;
        this._aLight.position.y = 10;
        this._aLight.position.z = 10;
    }

    _createDirectionalLight() {
        this._pointLight = new THREE.PointLight(new THREE.Color(GameConfig.pointLightLightColor), GameConfig.pointLightIntensity, GameConfig.pointLightDistance);
        this._pointLight.position.set(0, -10, -15);

        this._directLight = new THREE.DirectionalLight(new THREE.Color(GameConfig.directLightLightColor), GameConfig.directLightIntensity);
        this._directLight.position.set(-1, 6, -3);
    }

    _setupHelpers() {
        // this._spotLightHelper = new THREE.SpotLightHelper(this._spotLight, 0.2, 0xffffff);
    }

    _addToScene() {
        this.add(this._aLight, this._pointLight, this._directLight);
    }

    update(delta) {
    }
}